// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-i6uYEk","boundary":"boundary-D2w8ZX","label":"label-CW1nYl"};